export default __webpack_public_path__ + "static/media/i139sk.01f71330.webp";